import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface ILeadform_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ILeadform_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
}

export class Leadform_ScreenBase extends React.PureComponent<
  ILeadform_ScreenProps,
  any
> {
  leadform_685596_value_kuikaSelectBoxRef: React.RefObject<any>;
  leadform_326871_value_kuikaDatetimeRef: React.RefObject<any>;
  leadform_620190_value_kuikaSelectBoxRef: React.RefObject<any>;
  leadform_278865_value_kuikaSelectBoxRef: React.RefObject<any>;
  leadform_790561_value_kuikaSelectBoxRef: React.RefObject<any>;
  leadform_761360_value_kuikaSelectBoxRef: React.RefObject<any>;
  leadform_887975_value_kuikaPlacesAutocompleteInputRef: React.RefObject<any>;
  leadform_209092_value_kuikaLocationPickerComponentRef: React.RefObject<any>;
  leadform_713312_value_kuikaGalleryViewRef: React.RefObject<any>;
  ml = [
    {
      Id: "f6e17cbf-9877-1e37-1dda-7f0e2f0194a4",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "58f12691-42c0-4569-8d3d-7de148711af0",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "b33cd7c5-3520-4de4-9760-daeb8b98e3ba",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 911859, PropertyName: "label", Value: "Kaydet" },
        { Id: 526647, PropertyName: "value", Value: "Lead Oluşturma" },
        { Id: 866479, PropertyName: "value", Value: "Açıklama" },
        { Id: 701292, PropertyName: "placeholder", Value: "Açıklama girin..." },
        { Id: 70229, PropertyName: "value", Value: "Ürün Tipi" },
        {
          Id: 685596,
          PropertyName: "placeholder",
          Value: "Ürün tipi seçin...",
        },
        { Id: 590414, PropertyName: "value", Value: "Tahmini Ciro Büyüklüğü" },
        {
          Id: 836164,
          PropertyName: "placeholder",
          Value: "Tahmini Ciro Büyüklüğünü belirt..",
        },
        {
          Id: 53612,
          PropertyName: "value",
          Value: "Tahmini Gerçekleşme Zamanı",
        },
        {
          Id: 326871,
          PropertyName: "placeholder",
          Value: "Tahmini gerçekleşme zamanı...",
        },
        { Id: 890014, PropertyName: "value", Value: "Firma" },
        { Id: 620190, PropertyName: "placeholder", Value: "Firma seç..." },
        { Id: 674018, PropertyName: "value", Value: "Proje Adı" },
        { Id: 278865, PropertyName: "placeholder", Value: "Proje adı seç..." },
        { Id: 699346, PropertyName: "value", Value: "Kullanıcı Seç" },
        { Id: 790561, PropertyName: "placeholder", Value: "Kullanıcı seç..." },
        { Id: 806230, PropertyName: "value", Value: "İlgili Kişi" },
        {
          Id: 761360,
          PropertyName: "placeholder",
          Value: "İlgili kişi seç...",
        },
        { Id: 104948, PropertyName: "value", Value: "İlgili Kişi Telefon" },
        {
          Id: 44432,
          PropertyName: "placeholder",
          Value: "Telefon numarası...",
        },
        { Id: 709062, PropertyName: "value", Value: "İlgili Kişi Mail" },
        { Id: 525043, PropertyName: "placeholder", Value: "E-posta adresi..." },
        { Id: 430780, PropertyName: "value", Value: "Adres Seçimi" },
        { Id: 887975, PropertyName: "placeholder", Value: "Adres seç..." },
        { Id: 614892, PropertyName: "label", Value: "Fotoğraf Yükle" },
        {
          Id: 713312,
          PropertyName: "nodatafoundmessage",
          Value: "No data found.",
        },
        { Id: 737484, PropertyName: "label", Value: "Fotoğrafı Sil" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.leadform_685596_value_kuikaSelectBoxRef = React.createRef();
    this.leadform_326871_value_kuikaDatetimeRef = React.createRef();
    this.leadform_620190_value_kuikaSelectBoxRef = React.createRef();
    this.leadform_278865_value_kuikaSelectBoxRef = React.createRef();
    this.leadform_790561_value_kuikaSelectBoxRef = React.createRef();
    this.leadform_761360_value_kuikaSelectBoxRef = React.createRef();
    this.leadform_44432_value_kuikaTextInputRef = React.createRef();
    this.leadform_887975_value_kuikaPlacesAutocompleteInputRef =
      React.createRef();
    this.leadform_209092_value_kuikaLocationPickerComponentRef =
      React.createRef();
    this.leadform_713312_value_kuikaGalleryViewRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("leadform", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
    }

    KuikaAppManager.calculateAndSetBodyHeight("leadform", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("leadform", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      leadform_836164_value: undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  LeadformComponent_384083_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeadformComponent_268087_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
  }
}
